(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;
  var container = null;
  var previousStep = null;
  var lastTrigger = null;

  /* -----------------------------------------------------------------------
     SVG helpers
     ----------------------------------------------------------------------- */
  var CHECK_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 10.5L8 14.5L16 5" stroke="var(--wmp-white)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var CHEVRON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 5L15 12L9 19" stroke="var(--wmp-border-light, #EFEBE4)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* -----------------------------------------------------------------------
     Products config (RX metaobjects plus section-managed accessories/prism)
     ----------------------------------------------------------------------- */
  function loadProductsConfig() {
    var configEls = document.querySelectorAll('[id^="wmp-products-config"]');
    var raw = { lensPackages: [], lensTypes: [], accessories: [], prism: null };

    configEls.forEach(function (el) {
      try {
        var parsed = JSON.parse(el.textContent);
        raw.lensPackages = raw.lensPackages.concat(parsed.lensPackages || []);
        raw.lensTypes = raw.lensTypes.concat(parsed.lensTypes || []);
        raw.accessories = raw.accessories.concat(parsed.accessories || []);
        if (!raw.prism && parsed.prism) raw.prism = parsed.prism;
      } catch (e) { /* ignore */ }
    });

    function normalizeTypes(arr) {
      if (!arr) return [];
      var out = [];
      for (var i = 0; i < arr.length; i++) {
        var v = String(arr[i] || '').trim();
        if (v) out.push(v);
      }
      return out;
    }

    var lensPackages = (raw.lensPackages || []).map(function (p) {
      return {
        frameType: p.frameType,
        packageKey: p.packageKey,
        prescriptionTypes: normalizeTypes(p.prescriptionTypes),
        variantId: p.variantId,
        priceCents: p.priceCents || 0,
        comparePriceCents: p.comparePriceCents || 0,
        title: p.title || '',
        subtitle: p.subtitle || '',
        note: p.note || '',
        infoContent: p.infoContent || '',
        hasInfo: !!p.hasInfo,
        sourceHandle: p.sourceHandle || ''
      };
    });

    var lensTypes = (raw.lensTypes || []).map(function (t) {
      return {
        frameType: t.frameType,
        lensPackageKeys: normalizeTypes(t.lensPackageKeys),
        lensTypeKey: t.lensTypeKey,
        prescriptionTypes: normalizeTypes(t.prescriptionTypes),
        variantId: t.variantId,
        priceCents: t.priceCents || 0,
        comparePriceCents: t.comparePriceCents || 0,
        title: t.title || '',
        subtitle: t.subtitle || '',
        infoContent: t.infoContent || '',
        hasInfo: !!t.hasInfo,
        sourceHandle: t.sourceHandle || ''
      };
    });

    function warnInvalidConfig(kind, item, reason) {
      if (!window.console || typeof window.console.warn !== 'function') return;
      console.warn('[WMP] Ignoring invalid ' + kind + ' metaobject:', reason, item.sourceHandle || item);
    }

    lensPackages = lensPackages.filter(function (p) {
      if (!p.frameType) {
        warnInvalidConfig('lens package', p, 'missing frame_type');
        return false;
      }
      if (!p.packageKey) {
        warnInvalidConfig('lens package', p, 'missing package_key');
        return false;
      }
      if (!p.variantId) {
        warnInvalidConfig('lens package', p, 'missing product or purchasable variant');
        return false;
      }
      if (!p.prescriptionTypes.length) {
        warnInvalidConfig('lens package', p, 'missing prescription_types');
        return false;
      }
      return true;
    });

    lensTypes = lensTypes.filter(function (t) {
      if (!t.frameType) {
        warnInvalidConfig('lens type', t, 'missing package frame_type');
        return false;
      }
      if (!t.lensPackageKeys.length || !t.lensPackageKeys[0]) {
        warnInvalidConfig('lens type', t, 'missing owning package_key');
        return false;
      }
      if (!t.lensTypeKey) {
        warnInvalidConfig('lens type', t, 'missing lens_type_key');
        return false;
      }
      if (!t.variantId) {
        warnInvalidConfig('lens type', t, 'missing product or purchasable variant');
        return false;
      }
      if (!t.prescriptionTypes.length) {
        warnInvalidConfig('lens type', t, 'missing owning package prescription_types');
        return false;
      }
      return true;
    });

    var accessories = (raw.accessories || []).map(function (a) {
      return {
        key: a.key,
        variantId: a.variantId,
        priceCents: a.priceCents || 0,
        comparePriceCents: a.comparePriceCents || 0,
        title: a.title || '',
        subtitle: a.subtitle || '',
        iconKey: a.iconKey || a.key || '',
        image: a.image || ''
      };
    });

    var prism = raw.prism && raw.prism.variantId ? {
      variantId: raw.prism.variantId,
      priceCents: Number(raw.prism.priceCents || 0)
    } : null;

    function filterLensTypes(ft, rxType, pkgKey) {
      return lensTypes.filter(function (t) {
        if (ft && t.frameType !== ft) return false;
        if (pkgKey && t.lensPackageKeys.indexOf(pkgKey) === -1) return false;
        if (rxType && t.prescriptionTypes.indexOf(rxType) === -1) return false;
        return true;
      });
    }

    window.WmpProductsConfig = {
      lensPackages: lensPackages,
      lensTypes: lensTypes,
      accessories: accessories,
      prism: prism,

      getPrism: function () { return prism; },

      getLensPackages: function (opts) {
        opts = opts || {};
        var ft = opts.frameType;
        var rxType = opts.prescriptionType;
        return lensPackages.filter(function (p) {
          if (ft && p.frameType !== ft) return false;
          if (rxType && p.prescriptionTypes.indexOf(rxType) === -1) return false;

          // Enforce package-family logic regardless of admin misconfiguration.
          // Sunglasses support only non-polarized/polarized packages.
          // Clear frames must never show sunglasses-only package keys.
          if (ft === 'sunglasses') {
            if (p.packageKey !== 'non-polarized' && p.packageKey !== 'polarized') return false;
          } else if (ft === 'clear') {
            if (p.packageKey === 'non-polarized' || p.packageKey === 'polarized') return false;
          }

          return true;
        });
      },

      getLensTypes: function (opts) {
        opts = opts || {};
        var ft = opts.frameType;
        var rxType = opts.prescriptionType;
        var pkgKey = opts.lensPackageKey;
        return filterLensTypes(ft, rxType, pkgKey);
      },

      getAccessories: function () { return accessories.slice(); },

      findLensPackage: function (frameType, prescriptionType, packageKey) {
        for (var i = 0; i < lensPackages.length; i++) {
          var p = lensPackages[i];
          if (p.frameType === frameType &&
              p.packageKey === packageKey &&
              p.prescriptionTypes.indexOf(prescriptionType) !== -1) {
            return p;
          }
        }
        return null;
      },

      findLensType: function (frameType, prescriptionType, lensPackageKey, lensTypeKey) {
        for (var i = 0; i < lensTypes.length; i++) {
          var t = lensTypes[i];
          if (t.frameType === frameType &&
              t.lensPackageKeys.indexOf(lensPackageKey) !== -1 &&
              t.lensTypeKey === lensTypeKey &&
              t.prescriptionTypes.indexOf(prescriptionType) !== -1) {
            return t;
          }
        }
        return null;
      },

      findAccessory: function (key) {
        for (var i = 0; i < accessories.length; i++) {
          if (accessories[i].key === key) return accessories[i];
        }
        return null;
      }
    };
  }

  /* -----------------------------------------------------------------------
     Initialize
     ----------------------------------------------------------------------- */
  function init() {
    var root = document.getElementById('wmp-prescription-flow');
    if (!root) return;

    var shouldResumeRx = false;
    var resumeStep = null;
    try {
      var currentUrl = new URL(window.location.href);
      shouldResumeRx = currentUrl.searchParams.get('wmp-rx-resume') === '1';
      resumeStep = currentUrl.searchParams.get('wmp-rx-step') || null;
    } catch (e) {
      // no-op
    }

    // Move the overlay to <body> so position:fixed escapes any theme
    // containing-block (ancestors with transform/filter/will-change) and
    // the z-index participates in the root stacking context.
    var overlay = document.getElementById('wmp-flow-overlay');
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    container = document.getElementById('wmp-step-container');

    // Read product data from DOM attributes
    var productData = {
      title: root.getAttribute('data-product-title') || '',
      variant: root.getAttribute('data-product-variant') || '',
      image: root.getAttribute('data-product-image') || '',
      price: parseInt(root.getAttribute('data-product-price') || '0', 10),
      compare: parseInt(root.getAttribute('data-compare-price') || '0', 10),
      variantId: root.getAttribute('data-product-variant-id') || '',
      url: root.getAttribute('data-product-url') || '',
      handle: root.getAttribute('data-product-handle') || ''
    };

    var frameType = String(root.getAttribute('data-frame-type') || 'clear').toLowerCase().trim();
    if (frameType !== 'sunglasses') frameType = 'clear';
    var region = root.getAttribute('data-region') || 'us';
    var customerLoggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var customerId = root.getAttribute('data-customer-id') || '';

    // Load i18n strings
    var i18nEl = document.getElementById('wmp-i18n');
    if (i18nEl) {
      try { window.WmpI18n = JSON.parse(i18nEl.textContent); } catch (e) { window.WmpI18n = {}; }
    } else {
      window.WmpI18n = {};
    }

    // Load products config (lens packages/types from metaobjects; accessories/prism from blocks)
    loadProductsConfig();

    // Set initial state
    store.update({
      frameType: frameType,
      region: region,
      customer: { loggedIn: customerLoggedIn, id: customerId, savedRx: null },
      product: productData,
      pricing: {
        frame: productData.price,
        lenses: 0,
        accessories: 0,
        subtotal: productData.price
      }
    });

    // Pre-fill the Rx grid from a prior session (within 30 days) if present.
    store.hydrateRxFromSession();

    if (shouldResumeRx) {
      var stepSequence = store.getStepSequence();
      var targetStep = resumeStep && stepSequence.indexOf(resumeStep) > -1 ? resumeStep : 'enter-prescription';
      // Entering a prescription requires a selected type. A direct resume URL
      // may be opened in a fresh session where no saved Rx can provide it.
      if (targetStep === 'enter-prescription' && !store.get('prescriptionType')) {
        targetStep = 'prescription-type';
      }
      if (stepSequence.indexOf(targetStep) > -1) {
        store.set('currentStep', targetStep);
      }
    }

    // Initialize router
    router.init(store);

    if (shouldResumeRx) {
      open(null);
      try {
        var cleanedUrl = new URL(window.location.href);
        cleanedUrl.searchParams.delete('wmp-rx-resume');
        cleanedUrl.searchParams.delete('wmp-rx-step');
        history.replaceState(null, '', cleanedUrl.pathname + cleanedUrl.search + cleanedUrl.hash);
      } catch (e2) {
        // no-op
      }
    }

    // Subscribe to step changes
    store.subscribe('currentStep', onStepChange);

    // Subscribe to pricing changes
    store.subscribe('pricing', onPricingChange);

    // Initialize pricing display (render Frame price with strikethrough if on sale)
    onPricingChange(store.get('pricing'), store.getState());

    // Wire up navigation buttons
    bindNavigation(root);

    // Global overlay triggers
    document.addEventListener('click', onGlobalClick);
    document.addEventListener('keydown', onGlobalKeydown);

    // Wire up mobile price toggle
    bindMobilePriceToggle();
    bindInstallmentsInfoTooltip();

    // Render initial stepper
    renderStepper();

    // Render initial step
    onStepChange(store.get('currentStep'), null);

    // Update back button visibility
    updateBackButton();
  }

  function bindInstallmentsInfoTooltip() {
    var infoBtn = document.querySelector('[data-installments-info]');
    if (!infoBtn || !window.WmpInfoBubble) return;

    var show = function (target) {
      window.WmpInfoBubble.show(target, {
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
      });
    };

    infoBtn.addEventListener('mouseenter', function (e) {
      show(e.currentTarget);
    });
    infoBtn.addEventListener('mouseleave', function () {
      window.WmpInfoBubble.hide();
    });
    infoBtn.addEventListener('focus', function (e) {
      show(e.currentTarget);
    });
    infoBtn.addEventListener('blur', function () {
      window.WmpInfoBubble.hide();
    });
  }

  /* -----------------------------------------------------------------------
     Step Change Handler
     ----------------------------------------------------------------------- */
  function onStepChange(newStep, oldStep) {
    // Set current step on root for CSS hooks (e.g. hide mobile footer on review)
    var root = document.getElementById('wmp-prescription-flow');
    if (root) root.setAttribute('data-step', newStep);

    // Toggle sidebar processing note visibility: only show on final step
    try {
      var asideNote = document.querySelector('.wmp-flow__sidebar .wmp-flow__processing-note');
      var seq = store.getStepSequence();
      var isLast = seq.length > 0 && seq.indexOf(newStep) === seq.length - 1;
      if (asideNote) asideNote.style.display = isLast ? '' : 'none';
    } catch (e) {
      // no-op
    }

    // Destroy previous step
    if (oldStep && window.WmpSteps && window.WmpSteps[oldStep]) {
      window.WmpSteps[oldStep].destroy();
    }

    // Clear container
    if (container) {
      container.innerHTML = '';
    }

    // Render new step
    if (window.WmpSteps && window.WmpSteps[newStep]) {
      window.WmpSteps[newStep].render(container);
    } else {
      // Placeholder for steps not yet implemented
      renderPlaceholder(newStep);
    }

    // Update stepper
    renderStepper();

    // Update mobile progress
    renderMobileProgress();

    // Update mobile step title in sub-header
    updateMobileStepTitle(newStep);

    // Update back button visibility
    updateBackButton();

    // Update mobile action button text
    updateMobileAction(newStep);

    // Keep each step anchored at the top; otherwise long steps (like Enter
    // Prescription) can carry their scroll offset into the next step.
    if (oldStep && oldStep !== newStep) {
      resetFlowScrollPosition();
    }

    previousStep = newStep;
  }

  function resetFlowScrollPosition() {
    requestAnimationFrame(function () {
      var overlay = document.getElementById('wmp-flow-overlay');
      if (overlay && typeof overlay.scrollTo === 'function') {
        overlay.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } else if (overlay) {
        overlay.scrollTop = 0;
      }

      var main = document.querySelector('.wmp-flow__main');
      if (main && typeof main.scrollTo === 'function') {
        main.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } else if (main) {
        main.scrollTop = 0;
      }

      if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
    });
  }

  /* -----------------------------------------------------------------------
     Placeholder (for steps not yet built)
     ----------------------------------------------------------------------- */
  function renderPlaceholder(stepKey) {
    if (!container) return;
    var div = document.createElement('div');
    div.className = 'wmp-flow__placeholder';
    div.style.cssText = 'text-align:center;padding:60px 20px;color:#999;';

    var h = document.createElement('h2');
    h.className = 'wmp-flow__step-heading';
    h.textContent = store.getStepName(stepKey);
    div.appendChild(h);

    var p = document.createElement('p');
    p.className = 'wmp-b1';
    p.style.marginTop = '12px';
    p.textContent = 'This step will be implemented in Phase 2.';
    div.appendChild(p);

    container.appendChild(div);
  }

  /* -----------------------------------------------------------------------
     Desktop Stepper
     ----------------------------------------------------------------------- */
  function renderStepper() {
    var stepperEl = document.getElementById('wmp-stepper');
    if (!stepperEl) return;

    var seq = store.getStepSequence();
    var current = store.get('currentStep');
    var currentIdx = seq.indexOf(current);

    stepperEl.innerHTML = '';

    for (var i = 0; i < seq.length; i++) {
      var stepKey = seq[i];
      var isCompleted = store.isCompleted(stepKey);
      var isCurrent = stepKey === current;

      // Step element
      var stepEl = document.createElement('button');
      stepEl.className = 'wmp-stepper__step';
      if (isCompleted) stepEl.className += ' wmp-stepper__step--completed';
      if (isCurrent) stepEl.className += ' wmp-stepper__step--current';
      stepEl.setAttribute('type', 'button');

      if (isCompleted) {
        stepEl.setAttribute('data-step', stepKey);
        stepEl.addEventListener('click', onStepperClick);
      } else {
        stepEl.disabled = !isCurrent;
      }

      // Number or check
      if (isCompleted) {
        var checkSpan = document.createElement('span');
        checkSpan.className = 'wmp-stepper__check';
        checkSpan.innerHTML = CHECK_SVG;
        stepEl.appendChild(checkSpan);
      } else {
        var numSpan = document.createElement('span');
        numSpan.className = 'wmp-stepper__number';
        numSpan.textContent = String(i + 1);
        stepEl.appendChild(numSpan);
      }

      // Label
      var labelSpan = document.createElement('span');
      labelSpan.className = 'wmp-stepper__label';
      labelSpan.textContent = store.getStepName(stepKey);
      stepEl.appendChild(labelSpan);

      stepperEl.appendChild(stepEl);

      // Chevron separator (except last)
      if (i < seq.length - 1) {
        var chevron = document.createElement('span');
        chevron.className = 'wmp-stepper__chevron';
        chevron.innerHTML = CHEVRON_SVG;
        chevron.setAttribute('aria-hidden', 'true');
        stepperEl.appendChild(chevron);
      }
    }
  }

  function onStepperClick(e) {
    var btn = e.currentTarget;
    var stepKey = btn.getAttribute('data-step');
    if (stepKey) {
      store.resetStepsAfter(stepKey);
      router.navigate(stepKey);
    }
  }

  /* -----------------------------------------------------------------------
     Mobile Progress Ring
     ----------------------------------------------------------------------- */
  function renderMobileProgress() {
    var el = document.getElementById('wmp-mobile-progress');
    if (!el) return;

    var seq = store.getStepSequence();
    var current = store.get('currentStep');
    var currentIdx = seq.indexOf(current);
    var total = seq.length;
    var stepNum = currentIdx + 1;

    var svgSize = 60;
    var center = svgSize / 2;
    var radius = 24;
    var circumference = 2 * Math.PI * radius;
    var progress = stepNum / total;
    var dashoffset = circumference * (1 - progress);

    el.innerHTML =
      '<svg width="' + svgSize + '" height="' + svgSize + '" viewBox="0 0 ' + svgSize + ' ' + svgSize + '">' +
        '<circle cx="' + center + '" cy="' + center + '" r="' + radius + '" fill="none" stroke="#EAEAEA" stroke-width="2.5"/>' +
        '<circle cx="' + center + '" cy="' + center + '" r="' + radius + '" fill="none" stroke="#B47250" stroke-width="2.5" ' +
          'stroke-dasharray="' + circumference + '" ' +
          'stroke-dashoffset="' + dashoffset + '" ' +
          'stroke-linecap="round" ' +
          'transform="rotate(-90 ' + center + ' ' + center + ')"/>' +
        '<text x="' + center + '" y="' + (center + 4) + '" text-anchor="middle" font-family="Source Sans Pro, sans-serif" font-weight="600" font-size="14" fill="#282828">' +
          stepNum + ' of ' + total +
        '</text>' +
      '</svg>';
  }

  /* -----------------------------------------------------------------------
     Pricing
     ----------------------------------------------------------------------- */
  function onPricingChange(pricing) {
    var formatPrice = store.formatPrice;
    var subtotal = pricing.frame + pricing.lenses + pricing.accessories;

    // Desktop sidebar
    var frameEl = document.querySelector('[data-price-frame]');
    var lensesEl = document.querySelector('[data-price-lenses]');
    var subtotalEl = document.querySelector('[data-price-subtotal]');
    var installmentEl = document.querySelector('[data-price-installment]');

    var product = store.get('product') || {};
    var state = store.getState();
    if (frameEl) renderFramePrice(frameEl, pricing.frame, product.compare, formatPrice);
    if (lensesEl) renderLensesPrice(lensesEl, pricing.lenses, state, formatPrice);
    if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);
    if (installmentEl) installmentEl.textContent = formatPrice(Math.round(subtotal / 4));

    // Accessory line — only present once an add-on is selected (spec: appears
    // only if the user picks an accessory in the Eyewear Care Essentials step).
    updateAccessoryPriceRow('[data-price-row-accessories]', '[data-price-accessories]', pricing.accessories, formatPrice);

    // Mobile footer
    var mobileFrame = document.querySelector('[data-mobile-price-frame]');
    var mobileLenses = document.querySelector('[data-mobile-price-lenses]');
    var mobileSubtotal = document.getElementById('wmp-mobile-subtotal');

    if (mobileFrame) renderFramePrice(mobileFrame, pricing.frame, product.compare, formatPrice);
    if (mobileLenses) renderLensesPrice(mobileLenses, pricing.lenses, state, formatPrice);
    if (mobileSubtotal) mobileSubtotal.textContent = formatPrice(subtotal);

    updateAccessoryPriceRow('[data-mobile-price-row-accessories]', '[data-mobile-price-accessories]', pricing.accessories, formatPrice);
  }

  // Frame price cell: when on sale, sale price (red) + struck-through compare-at.
  function renderFramePrice(el, priceCents, compareCents, formatPrice) {
    if (compareCents && compareCents > priceCents) {
      el.innerHTML = '<span class="wmp-card__price--sale">' + formatPrice(priceCents) +
        '</span> <span class="wmp-card__price-original">' + formatPrice(compareCents) + '</span>';
    } else {
      el.textContent = formatPrice(priceCents);
    }
  }

  // Lenses price cell: sum of package + type + prism. Show sale if cumulative compare-at > actual price.
  function renderLensesPrice(el, lensesCents, state, formatPrice) {
    var comparePrice = getLensesCompareCents(state);
    if (comparePrice && comparePrice > lensesCents) {
      el.innerHTML = '<span class="wmp-card__price--sale">' + formatPrice(lensesCents) +
        '</span> <span class="wmp-card__price-original">' + formatPrice(comparePrice) + '</span>';
    } else {
      el.textContent = formatPrice(lensesCents);
    }
  }

  // Resolve cumulative compare-at price for lenses (package + type + prism).
  function getLensesCompareCents(state) {
    var comparePrice = 0;
    var cfg = window.WmpProductsConfig;

    // Package compare-at
    if (state.lensPackageVariantId && cfg && cfg.lensPackages) {
      var pkg = findByVariantId(cfg.lensPackages, state.lensPackageVariantId);
      if (pkg) {
        comparePrice += (pkg.comparePriceCents && pkg.comparePriceCents > pkg.priceCents)
          ? pkg.comparePriceCents
          : pkg.priceCents || 0;
      }
    }

    // Lens type compare-at
    if (state.lensTypeVariantId && cfg && cfg.lensTypes) {
      var type = findByVariantId(cfg.lensTypes, state.lensTypeVariantId);
      if (type) {
        comparePrice += (type.comparePriceCents && type.comparePriceCents > type.priceCents)
          ? type.comparePriceCents
          : type.priceCents || 0;
      }
    }

    // Prism (no compare-at, just add actual)
    comparePrice += state.pricing.prism || 0;

    return comparePrice > 0 ? comparePrice : 0;
  }

  // Helper: find config item by variant ID
  function findByVariantId(list, variantId) {
    if (!list || !variantId) return null;
    var target = String(variantId);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].variantId || '') === target) return list[i];
    }
    return null;
  }

  function updateAccessoryPriceRow(rowSel, valueSel, accessories, formatPrice) {
    var row = document.querySelector(rowSel);
    var valueEl = document.querySelector(valueSel);
    if (!row) return;

    var amount = Number(accessories || 0);
    if (amount > 0) {
      row.hidden = false;
      row.style.display = '';
      if (valueEl) valueEl.textContent = formatPrice(amount);
    } else {
      row.hidden = false;
      row.style.display = '';
      if (valueEl) valueEl.textContent = '—';
    }
  }

  /* -----------------------------------------------------------------------
     Flow focus order
     ----------------------------------------------------------------------- */
  var FOCUSABLE_SELECTOR = 'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable="true"], [tabindex]:not([tabindex="-1"])';

  function isVisibleFocusable(el) {
    if (!el || el.disabled) return false;
    if (el.getAttribute('tabindex') === '-1') return false;
    if (el.closest && el.closest('[hidden], [aria-hidden="true"]')) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse')) {
      return false;
    }

    return !!(el.offsetWidth || el.offsetHeight || (el.getClientRects && el.getClientRects().length));
  }

  function getFocusableWithin(root) {
    if (!root || !root.querySelectorAll) return [];
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisibleFocusable);
  }

  function getVisibleCloseButton() {
    var closeButtons = [
      document.getElementById('wmp-desktop-close'),
      document.getElementById('wmp-mobile-close')
    ];

    for (var i = 0; i < closeButtons.length; i++) {
      if (isVisibleFocusable(closeButtons[i])) return closeButtons[i];
    }

    return null;
  }

  function focusElement(el) {
    if (!el || typeof el.focus !== 'function') return;

    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  function focusCloseAfterStepEnd(e) {
    if (e.key !== 'Tab' || e.shiftKey || e.defaultPrevented) return false;

    var overlay = document.getElementById('wmp-flow-overlay');
    if (!overlay || overlay.hasAttribute('hidden')) return false;

    var innerModal = document.querySelector('.wmp-modal-backdrop--visible');
    if (innerModal) return false;

    var closeBtn = getVisibleCloseButton();
    if (!closeBtn) return false;

    var activeEl = document.activeElement;
    var stepContainer = document.getElementById('wmp-step-container');
    var stepFocusables = getFocusableWithin(stepContainer);
    var lastStepFocusable = stepFocusables.length ? stepFocusables[stepFocusables.length - 1] : null;
    var mobileFooter = document.querySelector('.wmp-flow__mobile-footer');
    var footerFocusables = getFocusableWithin(mobileFooter);
    var lastFooterFocusable = footerFocusables.length ? footerFocusables[footerFocusables.length - 1] : null;
    var isAtStepEnd = activeEl === lastStepFocusable && !footerFocusables.length;
    var isAtFooterEnd = activeEl === lastFooterFocusable;

    if (isAtStepEnd || isAtFooterEnd) {
      e.preventDefault();
      focusElement(closeBtn);
      return true;
    }

    return false;
  }

  /* -----------------------------------------------------------------------
     Navigation
     ----------------------------------------------------------------------- */
  function bindNavigation(root) {
    // Desktop back
    var desktopBack = document.getElementById('wmp-desktop-back');
    if (desktopBack) desktopBack.addEventListener('click', function () { router.back(); });

    // Mobile back
    var mobileBack = document.getElementById('wmp-mobile-back');
    if (mobileBack) mobileBack.addEventListener('click', function () { router.back(); });

    // Desktop close
    var desktopClose = document.getElementById('wmp-desktop-close');
    if (desktopClose) desktopClose.addEventListener('click', onClose);

    // Mobile close
    var mobileClose = document.getElementById('wmp-mobile-close');
    if (mobileClose) mobileClose.addEventListener('click', onClose);

    // Mobile action button
    var mobileAction = document.getElementById('wmp-mobile-action');
    if (mobileAction) mobileAction.addEventListener('click', onMobileAction);
  }

  function open(trigger) {
    var overlay = document.getElementById('wmp-flow-overlay');
    if (!overlay) return;

    lastTrigger = trigger || document.activeElement;
    overlay.removeAttribute('hidden');
    document.body.classList.add('wmp-flow-overlay-open');

    var closeBtn = document.getElementById('wmp-desktop-close')
                || document.getElementById('wmp-mobile-close');
    if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
  }

  function onClose() {
    var overlay = document.getElementById('wmp-flow-overlay');
    if (!overlay) return;

    overlay.setAttribute('hidden', '');
    document.body.classList.remove('wmp-flow-overlay-open');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;

    if (window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    var shouldReset = overlay.getAttribute('data-reset-on-close') === 'true';
    if (shouldReset && typeof store.reset === 'function') {
      store.reset();
      var firstStep = store.getStepSequence()[0];
      store.set('currentStep', firstStep);
      store.set('completedSteps', []);
    }
  }

  function onGlobalClick(e) {
    var helpTrigger = e.target.closest && e.target.closest('[data-wmp-help="lens-usages"]');
    if (helpTrigger) {
      e.preventDefault();
      openLensUsagesModal();
      return;
    }

    var trigger = e.target.closest && e.target.closest('[data-wmp-open]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  }

  function getFlowAsset(root, attrName, fallback) {
    if (!root) return fallback || '';
    return root.getAttribute(attrName) || fallback || '';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildModalIllustration(url, alt, extraClass) {
    var className = 'wmp-two-pds-modal__art';
    // if (extraClass) className += ' ' + extraClass;
    if (!url) {
      return '<div class="' + className + '" aria-hidden="true"></div>';
    }
    return '<div class="' + className + '">' +
      '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(alt) + '" loading="lazy" />' +
    '</div>';
  }

  function buildLensUsageImage(url, alt) {
    if (!url) return '';
    return '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(alt) + '" loading="lazy" />';
  }

  function buildTwoPdsCard(stepLabel, imageHtml, title, body) {
    var stepId = String(stepLabel || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    var labelId = 'wmp-two-pds-modal-' + stepId + '-title';

    return '' +
      '<article class="wmp-two-pds-modal__card" aria-labelledby="' + escapeHtml(labelId) + '">' +
        imageHtml +
        '<h4 class="wmp-s3" id="' + escapeHtml(labelId) + '">' + stepLabel + '</h4>' +
        '<p class="wmp-b2">' + title + '</p>' +
        '<p class="wmp-b2">' + body + '</p>' +
      '</article>';
  }

  function buildTwoPdsRulerButton(url, modifierClass) {
    return '' +
      '<a class="wmp-two-pds-modal__ruler-link ' + modifierClass + '" href="' + url + '" target="_blank" rel="noopener noreferrer">' +
        'PREVIEW PRINTABLE RULER' +
      '</a>';
  }

  function openTwoPdsModal() {
    if (!window.WmpModal || typeof window.WmpModal.open !== 'function') return;

    var root = document.getElementById('wmp-prescription-flow');
    var fallbackImg = getFlowAsset(root, 'data-ruler-icon', '');
    var contactUrl = getFlowAsset(root, 'data-two-pds-contact-url', '/pages/contact-us');
    var step1Img = getFlowAsset(root, 'data-two-pds-step-1-image', fallbackImg);
    var step2Img = getFlowAsset(root, 'data-two-pds-step-2-image', fallbackImg);
    var step3Img = getFlowAsset(root, 'data-two-pds-step-3-image', fallbackImg);
    var step4Img = getFlowAsset(root, 'data-two-pds-step-4-image', fallbackImg);
    var printableRulerUrl = 'https://cdn.shopify.com/s/files/1/0896/5742/files/WMP_Printable_Ruler.pdf?v=1783719508';

    var content = '' +
      '<div class="wmp-two-pds-modal">' +
        '<section class="wmp-two-pds-modal__intro">' +
          '<h3 class="wmp-two-pds-modal__eyebrow">WHAT IS PD?</h3>' +
          '<p class="wmp-b1">PD stands for pupillary distance. It is the distance in millimeters between the center of each pupil. This measurement helps us center your lenses correctly, so your vision feels natural and clear when you wear your glasses.</p>' +
          buildTwoPdsRulerButton(printableRulerUrl, 'wmp-two-pds-modal__ruler-link--mobile') +
        '</section>' +
        '<section class="wmp-two-pds-modal__panel">' +
          '<h3 class="wmp-two-pds-modal__panel-title">HOW TO MEASURE YOUR OWN PD</h3>' +
          '<div class="wmp-two-pds-modal__grid">' +
            buildTwoPdsCard('STEP 1', buildModalIllustration(step1Img, 'Print or grab a millimeter ruler', 'wmp-two-pds-modal__art--compact'), 'Print our <a href="' + printableRulerUrl + '" target="_blank" rel="noopener noreferrer">PD ruler</a> or use any ruler with millimeter markings', '') +
            buildTwoPdsCard('STEP 2', buildModalIllustration(step2Img, 'Line up the ruler with your right pupil'), 'Stand about eight inches from a mirror. Hold the ruler flat against your face and line the zero mark up with the center of your right pupil.', '') +
            buildTwoPdsCard('STEP 3', buildModalIllustration(step3Img, 'Keep your head still and close your left eye'), 'Close your left eye and keep your head still. Note where the center of your left pupil falls on the ruler.', '') +
            buildTwoPdsCard('STEP 4', buildModalIllustration(step4Img, 'Read the distance between your pupils on the ruler'), 'The distance in millimeters between those two points is your PD. You can also ask a friend to help if that feels easier.', '') +
          '</div>' +
          buildTwoPdsRulerButton(printableRulerUrl, 'wmp-two-pds-modal__ruler-link--desktop') +
        '</section>' +
        '<section class="wmp-two-pds-modal__footer">' +
          '<p class="wmp-b1">Still unsure? Our team can help.</p>' +
          '<a class="wmp-two-pds-modal__contact-link" href="' + contactUrl + '">Contact Us.</a>' +
        '</section>' +
      '</div>';

    window.WmpModal.open({
      content: content,
      size: 'lg',
      dialogClass: 'wmp-modal-dialog--two-pds',
      backdropClass: 'wmp-modal-backdrop--two-pds'
    });
  }

  function openLensUsagesModal() {
    if (!window.WmpModal || typeof window.WmpModal.open !== 'function') return;
    var i18n = window.WmpI18n || {};
    var modals = i18n.modals || {};
    var root = document.getElementById('wmp-prescription-flow');
    var singleVisionImg = root ? (root.getAttribute('data-single-vision-lenses-icon') || '') : '';
    var progressiveImg = root ? (root.getAttribute('data-progressive-lenses-icon') || '') : '';
    var readingImg = root ? (root.getAttribute('data-reading-lenses-icon') || '') : '';
    var singleVisionAlt = root ? (root.getAttribute('data-single-vision-lenses-alt') || 'Single vision lenses for one clear focus') : 'Single vision lenses for one clear focus';
    var progressiveAlt = root ? (root.getAttribute('data-progressive-lenses-alt') || 'Progressive lenses for near, intermediate, and distance vision') : 'Progressive lenses for near, intermediate, and distance vision';
    var readingAlt = root ? (root.getAttribute('data-reading-lenses-alt') || 'Reading lenses for close-range tasks') : 'Reading lenses for close-range tasks';

    var defaultContent = '' +
      '<div class="wmp-lens-usages">' +
        '<p class="wmp-b1">Your prescription tells us what you need. No ADD power? Go single vision. If your prescription includes ADD power,<br>progressive lenses are your best option. Not sure? We\'re here to help.</p>' +
        '<div class="wmp-lens-usages__grid" role="list" aria-label="Lens usage options">' +
          '<section class="wmp-lens-usage" role="listitem" aria-labelledby="wmp-lens-usage-single-title">' +
            '<div class="wmp-lens-usage__art">' +
              buildLensUsageImage(singleVisionImg, singleVisionAlt) +
            '</div>' +
            '<h4 class="wmp-s3" id="wmp-lens-usage-single-title">SINGLE VISION LENSES</h4>' +
            '<p class="wmp-b2">One prescription. One clear focus. Single vision lenses correct one viewing distance across the entire lens—distance, intermediate, or near.</p>' +
            '<p class="wmp-b2"><strong>Best For:</strong> If you only need vision correction at one range. Simple, precise, and comfortable for everyday wear.</p>' +
          '</section>' +
          '<section class="wmp-lens-usage" role="listitem" aria-labelledby="wmp-lens-usage-progressive-title">' +
            '<div class="wmp-lens-usage__art">' +
              buildLensUsageImage(progressiveImg, progressiveAlt) +
            '</div>' +
            '<h4 class="wmp-s3" id="wmp-lens-usage-progressive-title">PROGRESSIVE LENSES</h4>' +
            '<p class="wmp-b2">All distances. One seamless lens. Progressives correct near, intermediate, and distance vision in one lens with smooth transitions and no visible lines.</p>' +
            '<p class="wmp-b2"><strong>Best For:</strong> Moving between screens, reading, and distance throughout the day, without switching glasses.</p>' +
          '</section>' +
          '<section class="wmp-lens-usage" role="listitem" aria-labelledby="wmp-lens-usage-reading-title">' +
            '<div class="wmp-lens-usage__art">' +
              buildLensUsageImage(readingImg, readingAlt) +
            '</div>' +
            '<h4 class="wmp-s3" id="wmp-lens-usage-reading-title">READING</h4>' +
            '<p class="wmp-b2">Made for up-close. Near vision lenses are designed for close-range tasks like reading, texting, and computer work.</p>' +
            '<p class="wmp-b2"><strong>Best For:</strong> If you only need extra clarity up close.</p>' +
          '</section>' +
        '</div>' +
      '</div>';

    // Always use the screenshot-style layout for the Lens Usages modal (prefer consistent UI)
    window.WmpModal.open({
      title: modals.lens_usages_title || 'Single vision, near vision, or progressive: which is right for you?',
      content: defaultContent,
      size: 'lg',
      dialogClass: 'wmp-modal-dialog--lens-usages',
      backdropClass: 'wmp-modal-backdrop--lens-usages',
      initialFocus: 'close'
    });
  }

  function onGlobalKeydown(e) {
    if (e.key === 'Escape') {
      var overlay = document.getElementById('wmp-flow-overlay');
      if (!overlay || overlay.hasAttribute('hidden')) return;
      var innerModal = document.querySelector('.wmp-modal-backdrop--visible');
      if (innerModal) return;
      onClose();
      return;
    }

    if (focusCloseAfterStepEnd(e)) return;

    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = e.target.closest && e.target.closest('[data-wmp-open]');
    if (!trigger || trigger.tagName === 'BUTTON' || trigger.tagName === 'A') return;
    e.preventDefault();
    open(trigger);
  }

  function onMobileAction() {
    var current = store.get('currentStep');
    // If the step has its own action handler, defer to it
    if (window.WmpSteps && window.WmpSteps[current] && window.WmpSteps[current].onContinue) {
      window.WmpSteps[current].onContinue();
    } else {
      router.advance();
    }
  }

  function updateBackButton() {
    var seq = store.getStepSequence();
    var current = store.get('currentStep');
    var idx = seq.indexOf(current);
    var isFirst = idx === 0;

    var desktopBack = document.getElementById('wmp-desktop-back');
    var mobileBack = document.getElementById('wmp-mobile-back');

    if (desktopBack) desktopBack.style.visibility = isFirst ? 'hidden' : 'visible';
    if (mobileBack) mobileBack.style.visibility = isFirst ? 'hidden' : 'visible';
  }

  function updateMobileStepTitle(stepKey) {
    var titleEl = document.getElementById('wmp-mobile-step-title');
    if (titleEl) {
      titleEl.textContent = stepKey === 'review'
        ? 'REVIEW YOUR ORDER'
        : store.getStepName(stepKey);
    }
    // Clear subtitle — each step can populate via WmpApp.setMobileSubtitle()
    var subtitleEl = document.getElementById('wmp-mobile-step-subtitle');
    if (subtitleEl) subtitleEl.innerHTML = '';
  }

  // Expose helper for steps to set mobile subtitle (e.g. help links)
  window.WmpApp = window.WmpApp || {};
  window.WmpApp.setMobileSubtitle = function (html) {
    var el = document.getElementById('wmp-mobile-step-subtitle');
    if (el) el.innerHTML = html;
  };
  window.WmpApp.open = function (trigger) { open(trigger); };
  window.WmpApp.close = function () { onClose(); };
  // Expose the lens usages opener so other step scripts can trigger the same modal
  window.WmpApp.openLensUsagesModal = function () {
    try { openLensUsagesModal(); } catch (e) { /* ignore */ }
  };
  window.WmpApp.openTwoPdsModal = function () {
    try { openTwoPdsModal(); } catch (e) { /* ignore */ }
  };

  function updateMobileAction(stepKey) {
    var btn = document.getElementById('wmp-mobile-action');
    if (!btn) return;
    btn.textContent = stepKey === 'review' ? 'CHECKOUT' : 'CONTINUE';
  }

  /* -----------------------------------------------------------------------
     Mobile Price Toggle
     ----------------------------------------------------------------------- */
  function bindMobilePriceToggle() {
    var toggle = document.getElementById('wmp-price-toggle');
    var breakdown = document.getElementById('wmp-mobile-price-breakdown');
    if (!toggle || !breakdown) return;

    toggle.addEventListener('click', function () {
      var isOpen = !breakdown.hidden;
      breakdown.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      var chevron = toggle.querySelector('.wmp-flow__chevron');
      if (chevron) {
        chevron.classList.toggle('wmp-flow__chevron--open', !isOpen);
      }
    });
  }

  /* -----------------------------------------------------------------------
     Boot
     ----------------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
